<template>
  <div>
    <BaseTitle :title="$t(!editable ? 'content.school_view' : edit ? 'content.school_edit' : 'content.school_create')" />
    <v-row>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">{{ $t('information') }}</div>
              <v-row>
                <v-col md="6">
                  <form-group name="NPSN" :validator="$v.form.schoolNumber">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.schoolNumber"
                        v-bind="attrs"
                        label="NPSN"
                        :disabled="!editable"
                        @input="$v.form.schoolNumber.$touch()"
                        @blur="$v.form.schoolNumber.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <form-group :name="$t('form.school_name')" :validator="$v.form.schoolName">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.schoolName"
                        v-bind="attrs"
                        :label="$t('form.school_name')"
                        :disabled="!editable"
                        @input="$v.form.schoolName.$touch()"
                        @blur="$v.form.schoolName.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        :items="provinces"
                        :loading="loadingProvinces"
                        :label="$t('province')"
                        :disabled="!editable"
                        item-value="provinceId"
                        item-text="name"
                        v-bind="attrs"
                        v-model="form.provinceId"
                        @change="getCities"
                        @input="$v.form.provinceId.$touch()"
                        @blur="$v.form.provinceId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <form-group :name="$t('form.city')" :validator="$v.form.cityId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        :items="cities"
                        :loading="loadingCities"
                        :label="$t('city')"
                        :disabled="!editable"
                        item-value="cityId"
                        item-text="name"
                        v-bind="attrs"
                        v-model="form.cityId"
                        @change="getEducation"
                        @input="$v.form.cityId.$touch()"
                        @blur="$v.form.cityId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.education_level')" :validator="$v.form.educationalLevel">
                    <template slot-scope="{ attrs }">
                      <v-select
                        :items="educationList"
                        :loading="loadingEducation"
                        :label="$t('content.education_level')"
                        :disabled="!editable"
                        item-value="educationalLevel"
                        item-text="educationalLevel"
                        v-bind="attrs"
                        v-model="form.educationalLevel"
                        @input="$v.form.educationalLevel.$touch()"
                        @blur="$v.form.educationalLevel.$touch()"
                      />
                    </template>
                  </form-group>
                  <div class="app-section-title">{{ $t('form.datatype') }}</div>
                  <strong class="manual mt-2">Manual</strong>
                </v-col>
                <v-col md="6">
                  <form-group :name="$t('form.school_address')" :validator="$v.form.address">
                    <template slot-scope="{ attrs }">
                      <v-textarea
                        v-model="form.address"
                        v-bind="attrs"
                        :label="$t('form.school_address')"
                        :disabled="!editable"
                        @input="$v.form.address.$touch()"
                        @blur="$v.form.address.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
            <v-btn v-if="editable" color="primary" :loading="loading" class="btn-primary-custom" type="submit">
              {{ $t(edit ? 'save' : 'submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';
import { maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'SchoolForm',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseTitle
  },
  validations: function() {
    return {
      form: {
        address: { required, maxAddressLength: maxLength(255) },
        provinceId: { required },
        cityId: { required },
        educationalLevel: { required },
        schoolName: { required },
        schoolNumber: { required },
        synced: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      provinces: 'Reference/itemProvinces',
      status: 'Reference/itemStatus',
      currentRole: 'Auth/currentRole'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    }
  },
  data: () => ({
    form: {
      address: '',
      cityId: '',
      educationalLevel: '',
      provinceId: '',
      schoolName: '',
      schoolNumber: '',
      synced: ''
    },
    educationList: [],
    validationName: 'dynamic',
    edit: false,
    loading: false,
    loadingProvinces: false,
    loadingCities: false,
    loadingSchool: false,
    loadingEducation: false,
    hasLoad: false,
    showPhoto: false,
    logoUrl: null,
    menu: false,
    menuFrom: false,
    menuTo: false,
    currentUserId: null
  }),
  methods: {
    getData() {
      this.$store.dispatch('SchoolManage/fetchDetail', this.$route.params.id).then(res => {
        if (res.cityId) {
          this.loadingEducation = true;
          this.$store
            .dispatch('School/getEducation', res.cityId)
            .then(res => (this.educationList = res))
            .finally(() => (this.loadingEducation = false));
        }
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });

        this.currentUserId = res.primarySchoolAdminId;
        this.getCities();
        this.hasLoad = true;
      });
    },
    getEducation() {
      this.loadingEducation = true;
      this.$store
        .dispatch('School/getEducation', this.form.cityId)
        .then(res => (this.educationList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingEducation = false));
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.provinceId).finally(() => (this.loadingCities = false));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };
      this.$store
        .dispatch(`SchoolManage/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'SchoolV1UpdateSuccess' : '' }))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({ name: 'SchoolV1Index' });
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();

    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    } else {
      this.hasLoad = true;
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('beforeunload', this.preventNav));
  },
  beforeRouteLeave(to, from, next) {
    if (!this.edit && this.$v.$anyDirty && this.$v.$invalid) {
      if (!window.confirm(this.$t('alert.leave_message'))) {
        return;
      }
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
.manual {
  color: #fa6400;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
